import React, { type CSSProperties } from 'react'
import { Theme as ZionTheme, WhiteTheme } from '@fs/zion-ui'

type ThemeProps = {
  theme?: 'standard' | 'white'
  children: React.ReactNode
  // eslint-disable-next-line react/no-unused-prop-types
  dontFill?: boolean
  style?: CSSProperties
}

export default function TextTheme({ theme, children, style }: ThemeProps): JSX.Element {
  if (!theme) {
    return children as JSX.Element
  }

  if (theme === 'white') {
    return <WhiteTheme data-testid="zion-cms-theme-white">{children}</WhiteTheme>
  }

  return (
    <ZionTheme data-testid="zion-cms-theme-standard" theme="day" transparent style={style}>
      {children}
    </ZionTheme>
  )
}
